/* Dragonfly journey search. No dependencies.
   Data: assets/journey-situations.json, built by scripts/journey-search-merge.mjs.
   Entries are situations, topics or product lines; synonyms and route_only terms only route a query,
   they are never shown. A kind:'line' entry is a product line (WaterSwirl, QELBY, Mechow): its cards are
   featured products plus a card to the collection. Two chip rows: the B chips (Balance, Body, Building,
   Organisations) and the domain chips (Water, Light, Sound, Energy, Air). Only one row filters at a time. */
(function () {
  'use strict';

  var STOP = ' i im me my mine a an the in on at of to for and or with want wanted would like feel feeling have has get more better some about is are am be do dont can cant how what where when which that this it its our your you we they very much really just so too not no please need looking look '.split(' ')
    .reduce(function (o, w) { if (w) o[w] = 1; return o; }, {});
  var MAX = 5;

  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/['’]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function tokens(s) { return norm(s).split(' ').filter(function (t) { return t && !STOP[t]; }); }

  // Optimal string alignment distance, capped
  function osa(a, b, cap) {
    if (Math.abs(a.length - b.length) > cap) return cap + 1;
    var d = [], i, j;
    for (i = 0; i <= a.length; i++) { d[i] = [i]; }
    for (j = 0; j <= b.length; j++) { d[0][j] = j; }
    for (i = 1; i <= a.length; i++) {
      var rowMin = cap + 1;
      for (j = 1; j <= b.length; j++) {
        var c = a[i - 1] === b[j - 1] ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + c);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
        if (d[i][j] < rowMin) rowMin = d[i][j];
      }
      if (rowMin > cap) return cap + 1;
    }
    return d[a.length][b.length];
  }

  function buildIndex(entries) {
    return entries.map(function (e) {
      var phrases = [e.text].concat(e.synonyms || [], e.route_only || []).map(norm).filter(Boolean);
      var words = {};
      phrases.forEach(function (p) { p.split(' ').forEach(function (w) { if (w && !STOP[w]) words[w] = 1; }); });
      var tw = norm(e.text).split(' ').filter(function (w) { return w && !STOP[w]; });
      return { e: e, phrases: phrases, words: Object.keys(words), textWords: tw };
    });
  }

  function tokenScore(t, words) {
    var best = 0;
    for (var i = 0; i < words.length; i++) {
      var w = words[i], s = 0;
      if (w === t) s = 3;
      else if (t.length >= 2 && w.indexOf(t) === 0) s = 2.5;
      else if (w.length >= 4 && t.indexOf(w) === 0) s = 2;
      else if (t.length >= 3 && w.indexOf(t) > 0) s = 1.5;
      else if (t.length >= 4) {
        var cap = t.length >= 7 ? 2 : 1;
        var d = Math.min(osa(t, w, cap), w.length > t.length ? osa(t, w.slice(0, t.length), cap) : cap + 1);
        if (d <= cap) s = 1.4 - 0.2 * d;
      }
      if (s > best) { best = s; if (best === 3) break; }
    }
    return best;
  }

  function search(index, query, b, boostB, domain) {
    var q = norm(query), ts = tokens(query), results = [];
    if (!q) return results;
    index.forEach(function (row) {
      if (b && row.e.b !== b) return;
      if (domain && (row.e.domains || []).indexOf(domain) < 0) return;
      var score = 0, hit = 0;
      ts.forEach(function (t) { var s = tokenScore(t, row.words); if (s) { hit++; score += s + 0.6 * tokenScore(t, row.textWords); } });
      if (ts.length && hit < Math.ceil(ts.length / 2)) return;
      if (q.length >= 3) {
        // best phrase wins, not the first that matches: an exact synonym must beat a mid-sentence hit
        var ph = 0;
        for (var i = 0; i < row.phrases.length; i++) {
          var p = row.phrases[i], ps = 0;
          if (p === q) ps = 6;
          else if (p.indexOf(q) === 0) ps = 4;
          else if ((' ' + p).indexOf(' ' + q) >= 0) ps = 3;
          if (ps > ph) { ph = ps; if (ph === 6) break; }
        }
        // typing a product line's own name is unambiguous, so the line beats a situation sharing the term
        if (ph === 6 && row.e.kind === 'line') ph += 2.5;
        score += ph;
      }
      // the entry's own visible words beat a shared synonym; a hub's own B ranks a little higher
      if (score > 0 && q.length >= 3 && (' ' + norm(row.e.text) + ' ').indexOf(' ' + q) >= 0) score += 2;
      if (score > 0 && boostB && row.e.b === boostB) score += 1.5;
      if (score > 0) results.push({ e: row.e, score: score });
    });
    var KIND = { topic: 0, line: 1, situation: 2 };
    results.sort(function (x, y) { return y.score - x.score || ((KIND[x.e.kind] === undefined ? 3 : KIND[x.e.kind]) - (KIND[y.e.kind] === undefined ? 3 : KIND[y.e.kind])); });
    return results.map(function (r) { return r.e; });
  }

  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (k === 'text') n.textContent = attrs[k];
      else if (k === 'class') n.className = attrs[k];
      else n.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }

  function formatMoney(cents, fmt) {
    var v = (cents / 100);
    function sep(n, dec, th, dc) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(dc);
    }
    return (fmt || '€{{amount_with_comma_separator}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return sep(v, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return sep(v, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return sep(v, 0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return sep(v, 2, "'", '.');
      return sep(v, 2, ',', '.');
    }).replace(/<[^>]*>/g, '');
  }

  function waLink(number, text) { return 'https://wa.me/' + number + '?text=' + encodeURIComponent(text); }

  function init(root) {
    var input = root.querySelector('.js-journey-input');
    var list = root.querySelector('.js-journey-list');
    var status = root.querySelector('.js-journey-status');
    var panel = root.querySelector('.js-journey-panel');
    var chips = Array.prototype.slice.call(root.querySelectorAll('.js-journey-chip'));
    var domainChips = Array.prototype.slice.call(root.querySelectorAll('.js-journey-domain'));
    var moneyFmt = root.getAttribute('data-money-format');
    var locale = (root.getAttribute('data-locale') || 'en').toLowerCase().split('-')[0];
    // every visible string comes from locales/*.json through the section, never from this file
    var STR = (function () {
      var n = root.querySelector('.js-journey-strings');
      try { return n ? JSON.parse(n.textContent) : {}; } catch (err) { return {}; }
    })();
    function T(key, fallback, value) {
      var v = STR[key];
      if (typeof v !== 'string' || !v) v = fallback;
      return value === undefined ? v : v.replace('@@', value);
    }
    // an entry answers in the visitor's language when the data file carries that language
    function L(e, field) {
      var i = e.i18n && e.i18n[locale];
      return (i && i[field]) || e[field];
    }
    var userChoseB = false;
    var activeDomain = null;
    var data = null, index = null, activeB = root.getAttribute('data-default-filter') || null, items = [], active = -1, productCache = {};

    var ready = fetch(root.getAttribute('data-src'), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { data = j; index = buildIndex(j.entries); return j; });

    // the B label follows the visitor's language, falling back to the data file then the key
    function bLabel(b) { return (STR.bs && STR.bs[b]) || (data && data.bLabels && data.bLabels[b]) || b; }
    function badge(b) { return el('span', { class: 'journey-badge journey-badge--' + String(b).toLowerCase(), text: bLabel(b) }); }
    // a product line says so, so the visitor knows a brand name landed on the line and not on a situation
    function badges(e) { return e.kind === 'line' ? [el('span', { class: 'journey-badge journey-badge--line', text: T('product_line', 'Product line') }), badge(e.b)] : [badge(e.b)]; }

    function close() {
      list.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant');
      active = -1;
    }

    function setActive(i) {
      var opts = list.querySelectorAll('[role="option"]');
      if (!opts.length) return;
      active = (i + opts.length) % opts.length;
      opts.forEach(function (o, k) { o.setAttribute('aria-selected', k === active ? 'true' : 'false'); });
      input.setAttribute('aria-activedescendant', opts[active].id);
      opts[active].scrollIntoView({ block: 'nearest' });
    }

    function render() {
      if (!index) return;
      var q = input.value;
      list.innerHTML = '';
      active = -1; input.removeAttribute('aria-activedescendant');
      // 0 is a real rank here, so never fall back with ||
      var KINDORDER = { line: 0, topic: 1, situation: 2 };
      var kindRank = function (k) { return KINDORDER[k] === undefined ? 3 : KINDORDER[k]; };
      if (!q.trim()) {
        if (activeDomain) {
          // a domain chip lists the product lines in that domain first, then its topics and situations
          items = data.entries.filter(function (e) { return (e.domains || []).indexOf(activeDomain) >= 0; })
            .sort(function (x, y) { return kindRank(x.kind) - kindRank(y.kind); });
        } else {
          items = activeB ? data.entries.filter(function (e) { return e.b === activeB && e.kind === 'situation'; }) : [];
        }
      } else {
        // A preselected hub chip only ranks its own B higher; only a chip the visitor pressed filters
        items = (userChoseB ? search(index, q, activeB, null, activeDomain) : search(index, q, null, activeB, activeDomain)).slice(0, MAX);
      }
      if (!q.trim() && !activeB && !activeDomain) { close(); status.textContent = ''; return; }
      items.forEach(function (e, i) {
        var li = el('li', { id: root.id + '-opt-' + i, role: 'option', 'aria-selected': 'false', class: 'journey-option' },
          [el('span', { class: 'journey-option__text', text: L(e, 'text') }), el('span', { class: 'journey-option__badges' }, badges(e))]);
        li.addEventListener('mousedown', function (ev) { ev.preventDefault(); });
        li.addEventListener('click', function () { choose(e, true); });
        list.appendChild(li);
      });
      if (!items.length) {
        var note = el('li', { class: 'journey-empty', role: 'presentation' }, [
          el('span', { text: T('own_words', 'Tell us in your own words, we will point you the right way.') }),
          el('a', { class: 'journey-wa journey-wa--small', href: waLink(data.whatsapp, T('wa_about', 'Hello Dragonfly, I would like to talk about:') + ' ' + q.trim()), target: '_blank', rel: 'noopener' }, [T('whatsapp', 'Talk to Dragonfly on WhatsApp')]),
          el('a', { class: 'journey-consult journey-email--small', href: '/pages/contact' }, [T('email', 'Send us an email')])
        ]);
        list.appendChild(note);
      }
      list.hidden = false; input.setAttribute('aria-expanded', 'true');
      status.textContent = items.length ? (items.length === 1 ? T('status_one', '1 suggestion, use up and down to choose') : T('status_many', '@@ suggestions, use up and down to choose', items.length)) : T('status_none', 'No match yet. You can tell us in your own words on WhatsApp.');
    }

    function fetchProduct(handle) {
      if (!productCache[handle]) {
        var root_ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        productCache[handle] = fetch(root_ + 'products/' + encodeURIComponent(handle) + '.js')
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
      }
      return productCache[handle];
    }

    function imgUrl(src, w) {
      if (!src) return '';
      if (src.indexOf('//') === 0) src = 'https:' + src;
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }

    function card(c, e) {
      var li = el('li', { class: 'journey-card journey-card--' + c.type });
      if (c.type === 'product') {
        li.classList.add('journey-card--loading');
        li.appendChild(el('span', { class: 'journey-card__media journey-card__placeholder', 'aria-hidden': 'true' }));
        li.appendChild(el('span', { class: 'journey-card__title', text: c.title || T('loading', 'Loading') }));
        fetchProduct(c.handle).then(function (p) {
          li.innerHTML = '';
          li.classList.remove('journey-card--loading');
          var title = c.title || p.title;
          var a = el('a', { class: 'journey-card__link', href: p.url || ('/products/' + encodeURIComponent(c.handle)) });
          if (p.featured_image) {
            a.appendChild(el('span', { class: 'journey-card__media' }, [el('img', { src: imgUrl(p.featured_image, 480), srcset: imgUrl(p.featured_image, 320) + ' 320w, ' + imgUrl(p.featured_image, 640) + ' 640w', sizes: '(min-width: 750px) 220px, 45vw', alt: '', loading: 'lazy', width: '320', height: '320' })]));
          } else {
            a.appendChild(el('span', { class: 'journey-card__media journey-card__placeholder', 'aria-hidden': 'true' }, [el('span', { text: T('brand', 'Dragonfly') })]));
          }
          a.appendChild(el('span', { class: 'journey-card__title', text: title }));
          var price = p.price > 0 ? ((p.price_varies ? T('price_from', 'From') + ' ' : '') + formatMoney(p.price, moneyFmt)) : (c.label || T('see_details', 'See details'));
          a.appendChild(el('span', { class: 'journey-card__price', text: price }));
          li.appendChild(a);
        }).catch(function () { li.remove(); });
      } else {
        // a collection card carries no words in the data file, so they come from locales/*.json
        if (c.type === 'collection') {
          c = {
            type: c.type, url: c.url,
            title: c.title || T('line_all', 'All @@', L(e, 'text')),
            text: c.text || T('line_every', 'Every size and version in the line'),
            label: c.label || T('see_the_line', 'See the line'),
          };
        }
        var waText = e.kind === 'line' ? T('wa_line', 'Hello Dragonfly, I would like to know more about @@', L(e, 'text')) : e.whatsapp;
        var href = c.type === 'talk' ? waLink(data.whatsapp, waText) : c.url;
        var attrs = { class: 'journey-card__link', href: href };
        if (/^https?:/.test(href)) { attrs.target = '_blank'; attrs.rel = 'noopener'; }
        li.appendChild(el('a', attrs, [
          el('span', { class: 'journey-card__media journey-card__placeholder journey-card__placeholder--' + c.type, 'aria-hidden': 'true' }, [el('span', { text: c.type === 'talk' ? T('talk', 'Talk') : c.type === 'collection' ? T('the_line', 'The line') : c.url === '#contact-form' ? T('programme', 'Programme') : T('sessions', 'Sessions') })]),
          el('span', { class: 'journey-card__title', text: c.title }),
          el('span', { class: 'journey-card__text', text: c.text || '' }),
          el('span', { class: 'journey-card__cta', text: c.label || T('open', 'Open') })
        ]));
      }
      return li;
    }

    function choose(e, push) {
      close();
      input.value = L(e, 'text');
      panel.innerHTML = '';
      var h = el('h3', { class: 'journey-result__title', tabindex: '-1' }, [L(e, 'text')]);
      var head = el('div', { class: 'journey-result__head' }, [el('span', { class: 'journey-result__badges' }, badges(e)), h]);
      var cards = el('ul', { class: 'journey-cards', role: 'list' });
      (L(e, 'cards') || []).slice(0, e.max_cards || 4).forEach(function (c) { cards.appendChild(card(c, e)); });
      var again = (function () { var b = el('button', { type: 'button', class: 'journey-again', text: e.kind === 'line' ? T('look_for_something_else', 'Look for something else') : T('choose_another', 'Choose another situation') }); b.addEventListener('click', reset); return b; })();
      // Free call first wherever a result leads to a Personal Consult (Hans, 2026-09-15)
      var actions = e.free_call
        ? el('div', { class: 'journey-result__actions' }, [
            el('a', { class: 'journey-wa', href: waLink(data.whatsapp, T('wa_free_call', 'Hello Dragonfly, I would like a free call about:') + ' ' + L(e, 'text')), target: '_blank', rel: 'noopener' }, [T('free_call', 'Start with a free call')]),
            el('a', { class: 'journey-consult', href: data.consultUrl || '/pages/balance' }, [T('see_consult', 'See Personal Consult')]),
            el('a', { class: 'journey-consult', href: '/pages/contact' }, [T('email', 'Send us an email')]),
            again
          ])
        : el('div', { class: 'journey-result__actions' }, [
            el('a', { class: 'journey-wa', href: waLink(data.whatsapp, e.kind === 'line' ? T('wa_line', 'Hello Dragonfly, I would like to know more about @@', L(e, 'text')) : e.whatsapp), target: '_blank', rel: 'noopener' }, [T('whatsapp', 'Talk to Dragonfly on WhatsApp')]),
            el('a', { class: 'journey-consult', href: '/pages/contact' }, [T('email', 'Send us an email')]),
            again
          ]);
      panel.appendChild(head);
      panel.appendChild(el('p', { class: 'journey-result__desc', text: L(e, 'description') }));
      if (e.free_call) panel.appendChild(actions);
      panel.appendChild(cards);
      if ((e.support_products || []).length) {
        var sup = el('ul', { class: 'journey-cards journey-cards--support', role: 'list' });
        e.support_products.slice(0, 3).forEach(function (sp) { sup.appendChild(card({ type: 'product', handle: sp.handle, title: sp.title }, e)); });
        panel.appendChild(el('h4', { class: 'journey-result__subhead', text: T('support_products', 'Products that support your body') }));
        panel.appendChild(sup);
      }
      if (e.guide) {
        panel.appendChild(el('p', { class: 'journey-result__guide' }, [T('library_prefix', 'Read more in the Longevity Library:') + ' ', el('a', { href: e.guide.url, text: e.guide.title + ' ' + T('guide_suffix', 'guide') })]));
      }
      if (!e.free_call) panel.appendChild(actions);
      panel.hidden = false;
      if (push) {
        try { history.pushState(null, '', '#support=' + e.slug); } catch (err) { location.hash = 'support=' + e.slug; }
        h.focus({ preventScroll: true });
        var r = panel.getBoundingClientRect();
        if (r.top < 0 || r.top > window.innerHeight * 0.6) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function reset() {
      panel.hidden = true; panel.innerHTML = '';
      input.value = '';
      if (/^#support=/.test(location.hash)) { try { history.pushState(null, '', location.pathname + location.search); } catch (err) {} }
      input.focus();
      render();
    }

    function fromHash(scroll) {
      var m = /^#support=([a-z0-9-]+)/.exec(location.hash);
      if (!m) return;
      ready.then(function () {
        var e = data.entries.filter(function (x) { return x.slug === m[1]; })[0];
        if (!e) return;
        choose(e, false);
        if (scroll) setTimeout(function () {
          var h = panel.querySelector('.journey-result__title');
          panel.scrollIntoView({ block: 'start' });
          if (h) h.focus({ preventScroll: true });
        }, 50);
      });
    }

    input.addEventListener('input', function () { ready.then(render); });
    input.addEventListener('focus', function () { if (input.value.trim() || activeB || activeDomain) ready.then(render); });
    input.addEventListener('keydown', function (ev) {
      var open = !list.hidden;
      if (ev.key === 'ArrowDown') { ev.preventDefault(); if (!open) render(); setActive(active + 1); }
      else if (ev.key === 'ArrowUp') { ev.preventDefault(); if (!open) render(); setActive(active - 1); }
      else if (ev.key === 'Enter') {
        ev.preventDefault();
        ready.then(function () {
          if (!input.value.trim() && !activeB && !activeDomain) { input.value = ''; render(); showTellUs(); return; }
          if (list.hidden) render();
          var pick = items[active >= 0 ? active : 0];
          if (pick) choose(pick, true);
        });
      } else if (ev.key === 'Escape') {
        if (open) { ev.preventDefault(); close(); } else if (input.value) { ev.preventDefault(); input.value = ''; }
      }
    });
    input.addEventListener('blur', function () { setTimeout(function () { if (!root.contains(document.activeElement) && !list.matches(':hover')) close(); }, 150); });

    function showTellUs() {
      list.innerHTML = '';
      list.appendChild(el('li', { class: 'journey-empty', role: 'presentation' }, [
        el('span', { text: T('own_words', 'Tell us in your own words, we will point you the right way.') }),
        el('a', { class: 'journey-wa journey-wa--small', href: waLink(data.whatsapp, T('wa_about', 'Hello Dragonfly, I would like to talk about:') + ' '), target: '_blank', rel: 'noopener' }, [T('whatsapp', 'Talk to Dragonfly on WhatsApp')]),
        el('a', { class: 'journey-consult journey-email--small', href: '/pages/contact' }, [T('email', 'Send us an email')])
      ]));
      list.hidden = false; input.setAttribute('aria-expanded', 'true');
      status.textContent = T('status_type', 'Type your situation, or tell us in your own words on WhatsApp.');
    }

    function syncChips() {
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-b') === activeB ? 'true' : 'false'); });
      domainChips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-domain') === activeDomain ? 'true' : 'false'); });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var b = chip.getAttribute('data-b');
        activeB = activeB === b ? null : b;
        activeDomain = null;
        userChoseB = true;
        syncChips();
        if (!panel.hidden && input.value && data) {
          var cur = data.entries.filter(function (x) { return x.text === input.value; })[0];
          if (cur) input.value = '';
        }
        ready.then(render);
      });
    });

    domainChips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var d = chip.getAttribute('data-domain');
        activeDomain = activeDomain === d ? null : d;
        activeB = null;
        userChoseB = false;
        syncChips();
        if (!panel.hidden && input.value && data) {
          var cur = data.entries.filter(function (x) { return x.text === input.value; })[0];
          if (cur) input.value = '';
        }
        ready.then(render);
      });
    });

    syncChips();
    document.addEventListener('click', function (ev) { if (!root.contains(ev.target)) close(); });
    // Links such as situation tiles (href="#support=slug") and back/forward both change the hash
    window.addEventListener('hashchange', function () { if (/^#support=/.test(location.hash)) fromHash(true); });
    fromHash(true);
  }

  function boot() { document.querySelectorAll('.js-journey-search').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.js-journey-search'); if (r) init(r); });
})();
